import { render, staticRenderFns } from "./_Segment.vue?vue&type=template&id=754798e5&"
import script from "./_Segment.vue?vue&type=script&lang=js&"
export * from "./_Segment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports